import moment from 'moment';
import { MONTHS_DATA } from '../Constants/Constants';

export const FilterMonthStatements = (monthStatements: any, summary?: any) => {
    const date = moment(),
          currentMonth = date.month(),
          currentYear = Number(date.format('YYYY')),
          indexInString = (currentMonth + 1).toString(),
          statementMonth = indexInString.length === 1 ? '0' + indexInString : indexInString;

    let dataPresentMonthStatement: any = [];

    monthStatements.length && monthStatements.forEach((month: any) => {
        summary.referral_graph_details.length && summary.referral_graph_details.forEach((summaryData) => {

            const isMonthAvailableInSummary = Number(summaryData.calendarmonth) === Number(month.statementMonth) &&
                                                Number(summaryData.calendaryear) === Number(month.statementYear);

            const isDataAvailableInSummary = summaryData.numberofreferrals !== 0 ||
                                                summaryData.numberofregistrations !== 0 ||
                                                    summaryData.numberoftradedaccounts !== 0 ||
                                                        (Number(month.statementMonth) === (currentMonth + 1) && Number(summaryData.calendaryear) === currentYear);

            isMonthAvailableInSummary && isDataAvailableInSummary && dataPresentMonthStatement.push(month);
        });
    });

    if (dataPresentMonthStatement.length === 0) {
        const month = {
            'statementMonth': statementMonth,
            'statementYear': `${currentYear}`,
            'statementMonthString': MONTHS_DATA[currentMonth],
            'value': `${currentYear}${statementMonth}`
        };
        dataPresentMonthStatement.push(month);
    }
    return dataPresentMonthStatement;
}
